import { Heading } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { AboutComponent } from '@/widgets/AboutComponent';
import { CardsBlock } from '@/widgets/CardsBlock';
import { RequestAccessModal } from '@/widgets/RequestAccessModal';
import { DefaultContainer } from '@/shared/ui';
import { MetaDecorator } from '@/shared/utils';
import { getBlocksData, getMainBlockData } from '../lib/blocksData';
import { getImpactsList } from '../lib/impactsList';

const LocalsProductPage = () => {
  const { t } = useTranslation();
  const mainBlockData = getMainBlockData(t);
  const blocksData = getBlocksData(t);
  const impactsList = getImpactsList(t);

  return (
    <>
      <MetaDecorator
        description='meta.products.locals.description'
        keywords='meta.products.locals.keywords'
        title='meta.products.locals.title'
      />
      <AboutComponent
        button={
          <RequestAccessModal
            buttonText={t('productPages.locals.bookDemo')}
            variant='solid'
          />
        }
        headingAs='h1'
        imageAlt={mainBlockData.heading}
        imageProps={{ isEager: true }}
        {...mainBlockData}
      />

      <DefaultContainer
        alignItems='center'
        bg='bg.light'
        gap='lg'
      >
        <Heading>{t('productPages.locals.amplifyHeading')}</Heading>
        <CardsBlock list={impactsList} />
      </DefaultContainer>

      {blocksData.map((info, index) => {
        const isOdd = index % 2 !== 0;

        return (
          <AboutComponent
            key={info.heading}
            imageAlt={info.heading}
            isOdd={isOdd}
            {...info}
          />
        );
      })}
    </>
  );
};

export default LocalsProductPage;
